var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 11 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7.58165 0.38147L6.63728 1.32584L9.1738 3.86236L10.1182 2.91799C10.606 2.4302 10.606 1.63998 10.1182 1.15218L9.34941 0.38147C8.86162 -0.106323 8.07139 -0.106323 7.5836 0.38147H7.58165ZM6.19632 1.7668L1.64813 6.31693C1.44521 6.51986 1.29692 6.77156 1.21497 7.04667L0.524259 9.39393C0.47548 9.55978 0.520357 9.73734 0.64133 9.85831C0.762302 9.97928 0.939859 10.0242 1.10376 9.97733L3.45102 9.28662C3.72613 9.20467 3.97783 9.05638 4.18076 8.85346L8.73284 4.30333L6.19632 1.7668Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }